import React from 'react';
import { IslandButton } from '@trevor/ui-components';
import { EDIT_QUERY_PRESENTATION_BUTTON } from '@/constants/test-ids';
import { NavigationButtonProps } from './types';

export const EditQuery: React.FC<NavigationButtonProps> = (props) => (
  <IslandButton
    data-testid={EDIT_QUERY_PRESENTATION_BUTTON}
    content="Edit query"
    tooltipContent="Edit your query"
    {...props}
  />
);
